import { useTranslation } from 'react-i18next';

const useTranslations = useTranslation;

export default useTranslations;
